import "flatpickr/dist/themes/material_blue.css";
import "../../../assets/scss/datatables.scss";

import * as confirmAction from "../../../store/confirm/action";
import * as loadingAction from "../../../store/loading/action";
import * as messageAction from "../../../store/message/action";

import {
  Button,
  Card,
  CardBody,
  CardTitle,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
  Table,
} from "reactstrap";
import {
  GET_NOMINATION_CONF,
  GET_NOMINATION_DATA,
  baseUrl,
} from "../../../helpers/url_api_constant";
import { Link, useHistory, useParams } from "react-router-dom";

import React, { useEffect, useState } from "react";
import { getPermission, getUserToken } from "../../../helpers/auth_helper";

import BootstrapTable from "react-bootstrap-table-next";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { post } from "../../../helpers/api_helper";
//i18n
import { withTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

function ViewerNomDayDetail(props) {
  let history = useHistory();
  let { pid } = useParams();
  const dispatch = useDispatch();
  const permission = getPermission();
  const searchObj = { NOMINATECONF_PID: pid, SHIPPER_NAME: "", CONRACT_POINT: "", NOMINATE_NAME: "" };
  // const createObj = {};
  const pidInfoNomDay = { PID: pid };
  const [dataDetailNomDay, setDataDetailNomDay] = useState({});

  const [modelDeviceList, setModelDeviceList] = useState([]);
  // const [createModel, setCreateModel] = useState(createObj);
  const [searchModel, setSearchModel] = useState(searchObj);

  const listData = [
    {
      Id: "1",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "S_GSP1",
      Nomination: "121.5081887",
    },
    {
      Id: "2",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "S_GSP2",
      Nomination: "135.6945771",
    },
    {
      Id: "3",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "S_GSP3",
      Nomination: "135.6946479",
    },
    {
      Id: "4",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "S_GSP5",
      Nomination: "195.9202802",
    },
    {
      Id: "5",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "S_GSP6",
      Nomination: "273.0081133",
    },
    {
      Id: "6",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "S_GSP6RGC",
      Nomination: "12.68451322",
    },
    {
      Id: "7",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "LNG",
      Nomination: "351.4723536",
    },
    {
      Id: "8",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "BCC",
      Nomination: "2920.776",
    },
    {
      Id: "9",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "BPAM",
      Nomination: "5332.944",
    },
    {
      Id: "10",
      Date: "01/05/2021",
      Shipper: "PTT",
      ContactCode: "2016-CLF-001",
      NominationPoint: "GLOW2",
      Nomination: "15083.304",
    },
  ];

  const gotoPageViewerNominatoinDay = () => {
    // history.push("/viewer-nomination-day");
    history.push({
      pathname: "/viewer-nomination-day", state: {  // location state
        goBack: true,
      },
    });
  };

  //sort Column//
  const defaultSorted = [
    {
      dataField: "NOMINATE_NAME",
      order: "asc",
    },
  ];
  //sort Column//

  //Sort Page//
  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total ms-2">
      Showing {from} to {to} of {size} Results
    </span>
  );

  const options = {
    paginationSize: 4,
    pageStartIndex: 1,
    // alwaysShowAllBtns: true, // Always show next and previous button
    // withFirstAndLast: false, // Hide the going to First and Last page button
    // hideSizePerPage: true, // Hide the sizePerPage dropdown always
    // hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: true,
    sizePerPageList: [
      {
        text: "100",
        value: 100,
      },
      {
        text: "500",
        value: 500,
      },
      {
        text: "750",
        value: 750,
      },
      {
        text: "1000",
        value: 1000,
      },
    ],
  };
  //Sort Page//

  //render Index//
  const CountIndexRow = (cell, row, rowIndex) => rowIndex + 1;
  //render Index//

  //format date 
  const FormatDate = (date, format) => {
    return (
      <div>
        {moment(date).format(
          format
        )}
      </div>
      // Sep-21
    );
  };
  //format date

  const rowStyleFontWhite = (row, rowIndex) => {
    const style = {};
    // style.fontWeight = 'bold';
    style.color = 'white';

    return style;
  };


  //headerColumn
  const columns = [
    {
      dataField: "Dummy",
      text: "No.",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "5%",
        fontSize: "12px",
      },
      style: {
        width: "5%",
        fontSize: "12px",
      },
      formatter: CountIndexRow,
    },
    {
      dataField: "LOAD_DATE",
      text: "Gas Day",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "10%",
        fontSize: "12px",
      },
      style: {
        width: "10%",
        fontSize: "12px",
      },
      sort: true,
      isDummyField: true,
      formatter: (cellContent, row) => FormatDate(row.LOAD_DATE, "DD/MM/YYYY"),
    },
    {
      dataField: "SHIPPER_NAME",
      text: "Shipper Code",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "CONRACT_POINT",
      text: "Contact Code",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "15%",
        fontSize: "12px",
      },
      style: {
        width: "15%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "NOMINATE_NAME",
      text: "Nomination Point",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "16%",
        fontSize: "12px",
      },
      style: {
        width: "16%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "SHOW_NOMINATE_HV",
      text: "Heating Value",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "13%",
        fontSize: "12px",
      },
      style: {
        width: "13%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "SHOW_NOMINATE_VOLUME",
      text: "Nomination Volume",
      headerAlign: "center",
      align: "center",
      headerStyle: {
        width: "13%",
        fontSize: "12px",
      },
      style: {
        width: "13%",
        fontSize: "12px",
      },
      sort: true,
    },
    {
      dataField: "SHOW_NOMINATE_VALUE",
      text: "Daily Nomination",
      headerAlign: "center",
      align: "right",
      headerStyle: {
        width: "13%",
        fontSize: "12px",
      },
      style: {
        width: "13%",
        fontSize: "12px",
      },
      sort: true,
    },
  ];
  //headerColumn

  //onInit//
  useEffect(function () {
    resetSearch();
    // resetModel();
    // setModelDeviceList(listData);

    ///fixed header table
    let tableId = "viewer-nomday-detail-table";
    let scrollY = 189;
    function fixedTableHeader() {
      let headerTable = document.querySelector(`#${tableId} thead`);
      if (window.scrollY >= scrollY) {
        headerTable.classList.add("fixed-header");

        resizeTableHeader();
      } else {
        headerTable.classList.remove("fixed-header");
      }
    }
    function resizeTableHeader() {
      setTimeout(() => {
        let headerTable = document.querySelector(`#${tableId} thead`);
        let tr = document.querySelector(`#${tableId} tbody tr`);
        let th = headerTable.querySelector(".header-style");
        if (tr) {
          for (var i = 0; i < tr.childNodes.length; i++) {
            th.childNodes[i].style.width = `${tr.childNodes[i].offsetWidth}px`;
          }
        }
      }, 1);
    }
    window.addEventListener("scroll", fixedTableHeader);
    document
      .querySelector(`#vertical-menu-btn`)
      .addEventListener("click", resizeTableHeader);
    return () => {
      window.removeEventListener("scroll", fixedTableHeader);
      document.querySelector(`#vertical-menu-btn`)?.removeEventListener("click", resizeTableHeader);
    };
  }, []);
  //onInit//

  //Function CURL
  const resetSearch = () => {
    setSearchModel(searchObj);
    fetchData(searchObj);
    getDataDetailNomDay(pidInfoNomDay);
  };

  const onSearch = () => {
    // console.log(searchModel);
    fetchData(searchModel);
  };

  const getDataDetailNomDay = async (pidNomDay) => {
    // dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_NOMINATION_CONF, pidNomDay);
      // console.log(res);
      setDataDetailNomDay(res.data.nominateConfList[0]);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    // dispatch(loadingAction.hideLoading());
  };

  const downloadExcel = () => {
    dispatch(loadingAction.showLoading());
    const accessToken = JSON.parse(localStorage.getItem("accessToken"));
    fetch(baseUrl + "api/DownloadFile/downloadExcelNominateDayFileEx?NOMINATECONF_PID=" + pid, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/vnd.ms-excel',
        'Authorization': "Bearer " + accessToken.access_token,
        'TSOSESSIONID': getUserToken(),
      },
    })
      .then((response) => response.blob())
      .then((blob) => {
        // Create blob link to download
        const url = window.URL.createObjectURL(
          new Blob([blob]),
        );
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute(
          'download',
          // `FileName.xlsx`,
          dataDetailNomDay.UPLOAD_FILE
        );

        // Append to html link element page
        document.body.appendChild(link);

        // Start download
        link.click();

        // Clean up and remove the link
        link.parentNode.removeChild(link);
        dispatch(loadingAction.hideLoading());
      });
  };

  const fetchData = async (searchData) => {
    // console.log(searchData);

    const objSearch = {
      ...(searchData.SHIPPER_NAME != '') && { SHIPPER_NAME: searchData.SHIPPER_NAME },
      ...(searchData.CONRACT_POINT != '') && { CONRACT_POINT: searchData.CONRACT_POINT },
      ...(searchData.NOMINATE_NAME != '') && { NOMINATE_NAME: searchData.NOMINATE_NAME },

      NOMINATECONF_PID: searchData.NOMINATECONF_PID
    }
    dispatch(loadingAction.showLoading());
    try {
      let res = await post(GET_NOMINATION_DATA, objSearch);
      // console.log(res);
      setModelDeviceList(res.data.nominateDataList);
    } catch (err) {
      toggleModalMessage(err.message);
    }
    dispatch(loadingAction.hideLoading());
  };

  //Function CURL

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row>
            <Col xl="12">
              <Card>
                <CardBody>
                  <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                    <h1 className="mb-sm-0 font-size-20">
                      {" "}

                      {props.t("Nomination Detail ( Day )")}

                    </h1>
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <Link to="#" style={{ color: "#556ee6" }}>
                            Report Viewer
                          </Link>
                        </li>
                        <li className="breadcrumb-item">
                          <Link
                            to="/viewer-nomination-day"
                            style={{ color: "#556ee6" }}
                          >
                            Nomination ( Day )
                          </Link>
                        </li>
                        <li className="breadcrumb-item active">
                          Nomination Detail ( Day )
                        </li>
                      </ol>
                    </div>
                  </div>
                  <div>
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}> Gas Day : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{moment(dataDetailNomDay.UPLOAD_START).format(
                      "DD/MM/YYYY"
                    )}</span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ fontSize: "17px", color: "#FFFFFF" }}>Type : </span>&nbsp;&nbsp;<span style={{ fontSize: "17px", color: "#556ee6" }}>{dataDetailNomDay.UPLOADTYPE_NAME}</span>
                  </div>
                  <hr />

                  <Row>
                    <Col sm="3">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Shipper Code
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Shipper Code")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    SHIPPER_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.SHIPPER_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="3">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Contact Point
                        </Label>
                        <Col sm={8}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Contact Point")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    CONRACT_POINT: e.target.value,
                                  })
                                }
                                value={searchModel.CONRACT_POINT}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="4">
                      <FormGroup className="row mt-3">
                        <Label className="col-sm-4 col-form-label d-flex align-items-center justify-content-end">
                          Nomination Point
                        </Label>
                        <Col sm={6}>
                          <div className="search-box">
                            <div className="position-relative">
                              <input
                                type="text"
                                // style={{backgroundColor:"#FFFFFF"}}
                                className="form-control rounded-2 basicborder"
                                placeholder={props.t("Search Nomination Point")}
                                onChange={e =>
                                  setSearchModel({
                                    ...searchModel,
                                    NOMINATE_NAME: e.target.value,
                                  })
                                }
                                value={searchModel.NOMINATE_NAME}
                              />
                              {/* {props.t("Search Meter Point ID") + "..."} */}
                              <i className="bx bx-search-alt search-icon" />
                            </div>
                          </div>
                        </Col>
                      </FormGroup>
                    </Col>
                    <Col sm="2">
                      <FormGroup className="row">
                        <div className="d-flex align-items-center justify-content-start">
                          <Button color="info" className="mt-3" onClick={() => onSearch()}>
                            <i className="fas fa-search"></i>
                            &nbsp; Search
                          </Button>

                          <Button color="warning" className="mt-3 ms-2" onClick={() => resetSearch()}>
                            <i className="fas fa-redo-alt"></i>
                            &nbsp; Reset
                          </Button>
                        </div>
                      </FormGroup>
                    </Col>
                  </Row>
                  <Row className="mb-2 mt-3">
                    <Col sm="3">
                      <div className="d-grid gap-2 d-md-block">
                        {permission.vRVN && (
                          <Button
                            color="success"
                            className="mt-2 mb-2"
                            onClick={() => downloadExcel()}
                          >
                            <i className="fas fa-file-download fa-lg"></i>
                            &nbsp; Download Excel
                          </Button>
                        )}
                      </div>
                    </Col>
                    <Col
                      sm="9"
                      className="d-flex align-items-center justify-content-end"
                    >
                      <div className="d-grid gap-2 d-md-block">
                        <Button
                          onClick={() => gotoPageViewerNominatoinDay()}
                          // className="btn-rounded"
                          color="secondary"
                          className="mt-2 mb-2"
                        >
                          <i className="fas fa-angle-double-left"></i>
                          &nbsp; Back
                        </Button>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col sm="12">
                      <div>
                        <BootstrapTable
                          id="viewer-nomday-detail-table"
                          keyField="PID"
                          data={modelDeviceList}
                          columns={columns}
                          headerClasses="header-style"
                          rowStyle={rowStyleFontWhite}
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory(options)}
                        // hover
                        />
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>


      </div>
    </React.Fragment>
  );
}

ViewerNomDayDetail.propTypes = {
  t: PropTypes.any,
};

const mapStateToProps = ({ ViewerNomDayDetail }) => ({});

const mapDispatchToProps = dispatch => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(ViewerNomDayDetail));

// function RenderList(prop) {
//   console.log(prop);

//   return (<tr>
//     <td>{prop.indexlist}</td>
//     <td>{prop.data.MeterPointID}</td>
//     <td>{prop.data.Customer}</td>
//     <td>{prop.data.CustomerType}</td>
//     <td>{prop.data.CommunicationType}</td>
//     <td>{prop.data.Zone}</td>
//     <td>{prop.data.Point}</td>
//     <td>{prop.data.Region}</td>
//     <td>{prop.data.Area}</td>
//     <td>{prop.data.BVZoning}</td>
//     <td>{prop.data.BV}</td>
//     <td>
//       <Button className="me-1"
//         onClick={() =>
//           setPageAdd(true)
//         }
//         color="info"
//       >
//         <i className="far fa-edit"></i>
//         &nbsp; Edit
//       </Button>
//       <Button
//         onClick={() =>
//           setModalDelete(true)
//         }
//         // className="btn-rounded"
//         color="danger"
//       >
//         <i className="fas fa-trash-alt"></i>
//         &nbsp; Delete
//       </Button>
//     </td>
//   </tr>)
// }
